export enum DecimalByteUnit {
	/**
	 * Byte (B)
	 * 1 Byte
	 */
    Byte,

	/**
	 * Kilobyte (kB)
	 * 10^3 Byte = 1.000 Byte
	 */
    KB,

	/**
	 * Megabyte (MB)
	 * 10^6 Byte = 1.000.000 Byte
	 */
    MB,

	/**
	 * Gigabyte (GB)
	 * 10^9 Byte = 1.000.000.000 Byte
	 */
    GB,

	/**
	 * Terabyte (TB)
	 * 10^12 Byte = 1.000.000.000.000 Byte
	 */
    TB,

	/**
	 * Petabyte (PB)
	 * 10^15 Byte = 1.000.000.000.000.000 Byte
	 */
    PB
}
